import getCurrentUserSelector from 'modules/users/selectors/get-current'

function hasCurrentUserSelector () {
  return state => !!getCurrentUserSelector()(state)
}

export {
  hasCurrentUserSelector
}
